import * as pdfjsLib from "pdfjs-dist";

// Prefer an ESM worker hosted on unpkg (matches pdf.js v4+ ESM worker).
// If that resource is not reachable, fall back to the classic worker from cdnjs.
const version = pdfjsLib.version || 'latest';
const esmWorker = `https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
const classicWorker = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;

// Attempt a lightweight HEAD check for the ESM worker and set workerSrc accordingly.
(async () => {
  try {
    const res = await fetch(esmWorker, { method: 'HEAD', mode: 'cors' });
    pdfjsLib.GlobalWorkerOptions.workerSrc = res && res.ok ? esmWorker : classicWorker;
  } catch (e) {
    // Network/CORS failed — use classic worker as a robust fallback
    pdfjsLib.GlobalWorkerOptions.workerSrc = classicWorker;
  }
})();

export default pdfjsLib;
